module.exports = __webpack_public_path__ + "media/images/lb/687-e358b45697cb05e16c1b8a78472a8e03.svg";